import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import App from './App';

const LocalizedApp: React.FC = () => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  // Get token from search params, or will be handled by KeyLoader for OIDC
  const token = searchParams.get('token');

  if (pathname !== pathname.toLowerCase()) {
    if (token) {
      return (
        <Navigate to={pathname.toLowerCase() + `?token=${token}`} replace />
      );
    } else return <Navigate to={pathname.toLowerCase()} replace />;
  }

  return (
    <div>
      <App />
    </div>
  );
};

export default LocalizedApp;
